import { AccessField } from './field'
import { AccessObservations } from './observations'
import { AccessButtons } from './buttons'
import { GunControls } from './gun-controls'
import { useWindowFocus } from '../use-window-focus'

export const AccessForm = ({
  documento,
  setDocumento,
  showObservations,
  setShowObservations,
  observations,
  setObservations,
  clearObsAndResult,
  handleClear,
  handleSubmit,
  loading,
  officeId,
  isOfficePreselected,
  gunMode,
  setGunMode,
  gunDefaultEvent,
  setGunDefaultEvent,
  gunAutoSubmit,
  setGunAutoSubmit,
  canAutoSubmitNow
}) => {
  const windowActive = useWindowFocus()
  const scanArmed = gunMode && windowActive

  return (
    <form
      onSubmit={handleSubmit}
      onKeyDown={(e) => {
        if (gunMode && e.target?.id === 'documento-input' && e.key !== 'Tab') {
          e.preventDefault()
          e.stopPropagation()
        }
      }}
      className="space-y-4"
    >
      <GunControls
        gunMode={gunMode}
        setGunMode={setGunMode}
        gunDefaultEvent={gunDefaultEvent}
        setGunDefaultEvent={setGunDefaultEvent}
        gunAutoSubmit={gunAutoSubmit}
        setGunAutoSubmit={setGunAutoSubmit}
        canAutoSubmitNow={canAutoSubmitNow}
      />

      <AccessField
        documento={documento}
        setDocumento={setDocumento}
        clearObsAndResult={clearObsAndResult}
        handleClear={handleClear}
        gunMode={gunMode}
        scanArmed={scanArmed}
      />

      <AccessObservations
        showObservations={showObservations}
        setShowObservations={setShowObservations}
        observations={observations}
        setObservations={setObservations}
        locked={gunAutoSubmit}
      />

      <AccessButtons
        loading={loading}
        isOfficePreselected={isOfficePreselected}
        officeId={officeId}
        handleSubmit={handleSubmit}
      />
    </form>
  )
}